import {Component, Input} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ShareMessageType, ShareResult} from '../../domain';

@Component({
  selector: 'app-multishare-history-entry',
  template: `
    <table mat-table [dataSource]="processingDataSource"
           class="mat-elevation-z0">
      <ng-container matColumnDef="segmentId">
        <th mat-header-cell *matHeaderCellDef style="width: 82px;"> Segment ID</th>
        <td mat-cell *matCellDef="let element"> {{element['segmentId']}} </td>
      </ng-container>
      <ng-container matColumnDef="accountId">
        <th mat-header-cell *matHeaderCellDef style="min-width: 70px;"> Account ID</th>
        <td mat-cell *matCellDef="let element"> {{element['accountName'] || element['accountId']}} </td>
      </ng-container>
      <ng-container matColumnDef="error">
        <th mat-header-cell *matHeaderCellDef> Messages</th>
        <td mat-cell *matCellDef="let element">
          <p *ngFor="let item of element['shareMessages']">
            {{item.type === ShareMessageType.ERROR ? '❌' : (item.type === ShareMessageType.SUCCESS ? '✅' : '⚠️')}}
            {{item.message}}
          </p>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['segmentId', 'accountId', 'error']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['segmentId', 'accountId', 'error'];"></tr>
    </table>
  `,
  styleUrls: ['./multishare-history-entry.component.scss']
})
export class MultishareHistoryEntryComponent {
  processingDataSource = new MatTableDataSource<ShareResult>();
  readonly ShareMessageType = ShareMessageType;

  @Input() set shareResults(results: ShareResult[]) {
    if (results) {
      this.processingDataSource.data = results;
    }
  }

}
